/**
 * App Header
 */
import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { headerlogo, placeholderImg } from "../../../Entryfile/imagepath";
import useAuth from "../../../initialpage/hooks/useAuth";
import useGetData from "../StoreComponents/hooks/useGetData";
import { HrApi, imageApi } from "../../../initialpage/hooks/HrApi";

const StoreHeader = () => {
  const { logoutAction, user, setUser } = useAuth();
  const [employeeData, setEmployeeData] = useState({});
  const { CountData, requisitionUserNotification } = useGetData();
  const { data: totalRequisitionData } = CountData();
  const { data: userNotificationData } = requisitionUserNotification();

  const userNotification = Array.isArray(userNotificationData)
    ? userNotificationData.filter((item) => item.Status === "Pending To Accept")
    : [];

  const navigate = useNavigate();
  // console.log(totalRequisitionData);
  const logOutBtnHandler = () => {
    const statusLog = logoutAction();
    console.log("ddd", statusLog);
    if (statusLog === 1) {
      setUser({});
      navigate("/");
      window.location.reload();
    }
  };

  const logInStatus = parseInt(Cookies.get("Role"));
  // console.log(totalRequisitionData);
  // { refreshInterval: 2000 }
  // GET EMPLOYEE DATA USING EMPLOYEE ID
  const employeId = Cookies.get("E_Id");


  useEffect(() => {
    const getUsers = () => {
      fetch(`${HrApi}/hr/emp/getAllEmployeById/${employeId}`)
        .then((res) => {
          // You have to send it, as I have done below
          if (res.status >= 400) {
            throw new Error("Server responds with error!");
          }
          return res.json();
        })
        .then(
          (users) => {
            console.log("users");
            setEmployeeData(users.data);
          },

          (err) => {
            const mute = err;
            // setHasError(true);
          }
        );
    };
    if (employeId) getUsers();
  }, [employeId]);

  const userName = user?.name_english;
  const location = useLocation();
  let pathname = location.pathname;

  console.log("totalRequisitionData", totalRequisitionData);
  console.log("userNotification", userNotification);

  return (
    <div>
      <div>
        <div className="header ">
          {/* Logo */}
          <div className="header-left mt-2">
            <img src={headerlogo} width={60} height={40} alt="" />
          </div>

          {/* /Logo */}
          <a
            id="toggle_btn"
            href=""
            style={{
              display: pathname.includes("tasks")
                ? "none"
                : pathname.includes("compose")
                  ? "none"
                  : "",
            }}
          >
            <span className="bar-icon">
              <span />
              <span />
              <span />
            </span>
          </a>

          {/* Header Title */}
          <div className="page-title-box">
            <h3>InfoTech IT Solutions - Store </h3>
          </div>

          {/* /Header Title */}
          <a id="mobile_btn" className="mobile_btn" href="#sidebar">
            <i className="fa fa-bars" />
          </a>
          {/* Header Menu */}

          <ul className="nav user-menu">
            {/* Notifications */}
            {logInStatus === 5 || logInStatus === 41 || logInStatus === 24 ? (
              <>
                {logInStatus === 5 && (
                  <li className="nav-item dropdown">
                    <Link
                      to={"/requisition/requestProduct"}
                      className="dropdown-toggle nav-link"
                      data-bs-toggle="tooltip"
                      data-bs-placement="bottom"
                      title="Pending Request"
                    >
                      <i class="fa fa-comment"></i>
                      <span
                        className="badge badge-pill"
                        style={{ backgroundColor: " #DD4B39", color: "white" }}
                      >
                        {totalRequisitionData &&
                          totalRequisitionData?.PENDINGREQUESTCOUNT !== null
                          ? parseInt(totalRequisitionData?.PENDINGREQUESTCOUNT)
                          : "0"}
                      </span>
                    </Link>
                  </li>
                )}
                {logInStatus === 41 ||
                  (logInStatus === 24 && (
                    <li className="nav-item dropdown">
                      <Link
                        to={"/requisition/requestProduct"}
                        className="dropdown-toggle nav-link"
                        data-bs-toggle="tooltip"
                        data-bs-placement="bottom"
                        title="Approved Request"
                      >
                        <i class="fa fa-comment"></i>
                        <span
                          className="badge badge-pill"
                          style={{
                            backgroundColor: " #DD4B39",
                            color: "white",
                          }}
                        >
                          {totalRequisitionData &&
                            totalRequisitionData?.APPROVEDREQUESTCOUNT !== null
                            ? parseInt(
                              totalRequisitionData?.APPROVEDREQUESTCOUNT
                            ) +
                            parseInt(totalRequisitionData?.PENDINGREQUESTCOUNT)
                            : 0}
                        </span>
                      </Link>
                    </li>
                  ))}
                <li className="nav-item dropdown">
                  <Link
                    to={"/requisitions/pending"}
                    className="dropdown-toggle nav-link"
                    data-bs-toggle="tooltip"
                    data-bs-placement="bottom"
                    title="Pending"
                  >
                    <i className="fa fa-bell-o" />{" "}
                    <span
                      className="badge badge-pill"
                      style={{ backgroundColor: " #DD4B39", color: "white" }}
                    >
                      {totalRequisitionData
                        ? totalRequisitionData?.PENDINGCOUNT
                        : "0"}
                    </span>
                  </Link>
                </li>
                <li className="nav-item dropdown">
                  <Link
                    to={"/requisitions/approved"}
                    className="dropdown-toggle nav-link"
                    data-bs-toggle="tooltip"
                    data-bs-placement="bottom"
                    title="Approved"
                  >
                    <i className="fa fa-thumbs-up" />{" "}
                    <span
                      className="badge badge-pill"
                      style={{ backgroundColor: " #DD4B39", color: "white" }}
                    >
                      {totalRequisitionData
                        ? totalRequisitionData?.APPROVEDCOUNT
                        : "0"}
                    </span>
                  </Link>
                </li>
                <li className="nav-item dropdown">
                  <Link
                    to={"/viewstocklessproducts"}
                    className="dropdown-toggle nav-link"
                    data-bs-toggle="tooltip"
                    data-bs-placement="bottom"
                    title="Stock Less"
                  >
                    <i className="fa fa-gift" />{" "}
                    <span
                      className="badge badge-pill "
                      style={{ backgroundColor: " #DD4B39", color: "white" }}
                    >
                      {totalRequisitionData
                        ? totalRequisitionData?.STOCKALERT
                        : "0"}
                    </span>
                  </Link>
                </li>
              </>
            ) : (
              ""
            )}
            {/* userNotification.length */}
            <li className="nav-item dropdown">
              <Link
                to={"/requisition/view"}
                className="dropdown-toggle nav-link"
                data-bs-toggle="tooltip"
                data-bs-placement="bottom"
                title="Pending to approved"
              >
                <i className="fa fa-lightbulb" />
                <span
                  className="badge badge-pill"
                  style={{ backgroundColor: " #DD4B39", color: "white" }}
                >
                  {userNotification ? userNotification.length : "0"}
                </span>
              </Link>
            </li>

            <li className="nav-item dropdown has-arrow main-drop">
              <a
                href="#"
                className="dropdown-toggle nav-link"
                data-toggle="dropdown"
              >
                <span className="header-img">
                  <div className="avatar">
                    <img
                      className="avatar"
                      src={
                        employeeData?.PHOTO_PATH
                          ? `${imageApi}${employeeData?.PHOTO_PATH}`
                          : placeholderImg
                      }
                    />
                  </div>
                </span>
                <span>{userName}</span>
              </a>
              <div className="dropdown-menu">
                <a href="/hr/singleprofile" className="dropdown-item">
                  My Profile
                </a>
                <a href="/hr/changepassword" className="dropdown-item">
                  Change Password
                </a>
                <a
                  onClick={() => logOutBtnHandler()}
                  className="dropdown-item"
                  href="/"
                >
                  Logout
                </a>
              </div>
            </li>
          </ul>
          {/* /Header Menu */}
          {/* Mobile Menu */}
          <div className="dropdown mobile-user-menu">
            <a
              href="#"
              className="nav-link dropdown-toggle"
              data-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="fa fa-ellipsis-v" />
            </a>
            <div className="dropdown-menu dropdown-menu-right">
              <a className="dropdown-item" href="/hr/singleprofile">
                My Profile
              </a>
              <a onClick={logoutAction} className="dropdown-item" href="/">
                Logout
              </a>
            </div>
          </div>
          {/* /Mobile Menu */}
        </div>
      </div>
      <Outlet />
    </div>
  );
};

export default StoreHeader;
